import { Icon } from "@stenajs-webui/elements";

import type { SpecialBookingIconMeta } from "../use-cases/manage/grid/utils/bookingSpecialProperties";

interface IconWithDescriptionProps {
  iconInfo: SpecialBookingIconMeta | null;
}

export const IconWithDescription = ({ iconInfo }: IconWithDescriptionProps) => {
  if (!iconInfo) {
    return null;
  }

  return (
    <div title={iconInfo.description}>
      <Icon icon={iconInfo.icon} size={16} />
    </div>
  );
};
